import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex items-center justify-center gap-2 text-xs" }

import { LoaderCircle } from 'lucide-vue-next';
    import { useI18n } from 'vue-i18n';
    import { type HTMLAttributes, computed } from 'vue';
    import { cn } from '@/lib/utils';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
    size: { default: 'md' },
    class: {}
  },
  setup(__props: any) {

    const props = __props;

    const { t } = useI18n();

    const size = computed(() => {
        return {
            xs: 'max-h-20',
            sm: 'max-h-32',
            md: 'max-h-52',
            lg: 'max-h-64',
            xl: 'max-h-80',
        }[props.size];
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(cn)('flex h-full items-center justify-center p-4', size.value, props.class))
  }, [
    _createElementVNode("span", _hoisted_1, [
      _createVNode(_unref(LoaderCircle), { class: "text-primary size-5 animate-spin" }),
      _createTextVNode(" " + _toDisplayString(_unref(t)('datatables.loading')), 1)
    ])
  ], 2))
}
}

})